/**
 * Dr. Riva - Fera Widget Customizations
 * Transforms and enhances the Fera reviews widget
 */

(function() {
  'use strict';

  // Prevent duplicate initialization when script is injected more than once.
  if (window.__drFeraWidgetInitialized) {
    return;
  }
  window.__drFeraWidgetInitialized = true;

  var DR_FERA_WIDGET_ROOTS_SELECTOR = '.fera-allReviews-widget, .fera-productReviews-widget';
  var DR_FERA_PRODUCT_RATING_SELECTOR = '[data-dr-fera-product-rating]';

  /**
   * Manual product handle -> series accent color map.
   * Keep keys lowercase and values as valid CSS colors.
   */
  var DR_FERA_PRODUCT_SERIES_COLORS = {
    'גל-ניקוי': '#50BD93'
  };

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function pushUnique(arr, item) {
    if (!item) return;
    if (arr.indexOf(item) === -1) {
      arr.push(item);
    }
  }

  function renderProductRating(root, rating) {
    var average = parseFloat(rating && rating.average) || 0;
    var count = parseInt(rating && rating.count, 10) || 0;
    var content = root.querySelector('[data-dr-fera-rating-content]');
    var noReviews = root.querySelector('[data-dr-fera-no-reviews]');

    if (average > 0 && count > 0) {
      var value = root.querySelector('[data-dr-fera-rating-value]');
      var stars = root.querySelector('[data-dr-fera-rating-stars]');
      var fill = root.querySelector('[data-dr-fera-rating-fill]');
      var countLink = root.querySelector('[data-dr-fera-rating-count]');
      var fillPercent = Math.min(Math.max((average / 5) * 100, 0), 100);

      value.textContent = average.toFixed(1);
      stars.setAttribute('aria-label', average.toFixed(1) + ' מתוך 5 כוכבים');
      fill.style.width = fillPercent + '%';
      countLink.textContent = count + ' חוות דעת מאומתות';
      content.hidden = false;
      noReviews.hidden = true;
    } else {
      content.hidden = true;
      noReviews.hidden = false;
    }

    root.hidden = false;
    root.dataset.drFeraRatingState = 'loaded';
  }

  function loadProductRating(root) {
    if (!root || root.dataset.drFeraRatingState) return;

    var productId = root.dataset.productId;
    if (!productId) return;

    root.dataset.drFeraRatingState = 'loading';
    var attempts = 0;

    function retrieveWhenReady() {
      attempts += 1;

      if (window.fera && window.fera.api && typeof window.fera.api.retrieveProductRating === 'function') {
        window.fera.api.retrieveProductRating(productId)
          .then(function(rating) {
            renderProductRating(root, rating);
          })
          .catch(function() {
            root.dataset.drFeraRatingState = 'failed';
          });
        return;
      }

      if (attempts < 100) {
        window.setTimeout(retrieveWhenReady, 100);
      } else {
        root.dataset.drFeraRatingState = 'failed';
      }
    }

    retrieveWhenReady();
  }

  function syncProductRatings(scope) {
    var searchRoot = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (searchRoot.matches && searchRoot.matches(DR_FERA_PRODUCT_RATING_SELECTOR)) {
      roots.push(searchRoot);
    }

    toArray(searchRoot.querySelectorAll(DR_FERA_PRODUCT_RATING_SELECTOR)).forEach(function(root) {
      pushUnique(roots, root);
    });

    roots.forEach(loadProductRating);
  }

  function getWidgetRootsFromScope(scope) {
    // No scope means process all currently available widget roots.
    if (!scope) {
      return toArray(document.querySelectorAll(DR_FERA_WIDGET_ROOTS_SELECTOR));
    }

    // Already a list/array of roots.
    if (Array.isArray(scope)) {
      return scope.filter(function(root) {
        return !!(root && root.nodeType === 1 && root.matches && root.matches(DR_FERA_WIDGET_ROOTS_SELECTOR));
      });
    }

    // Single element scope.
    if (scope.nodeType === 1) {
      var roots = [];
      if (scope.matches && scope.matches(DR_FERA_WIDGET_ROOTS_SELECTOR)) {
        pushUnique(roots, scope);
      }
      if (scope.querySelectorAll) {
        toArray(scope.querySelectorAll(DR_FERA_WIDGET_ROOTS_SELECTOR)).forEach(function(root) {
          pushUnique(roots, root);
        });
      }
      return roots;
    }

    return [];
  }

  /**
   * Transform review count to Hebrew format: "סה"כ X חוות דעת"
   */
  function transformReviewCount(scope) {
    getWidgetRootsFromScope(scope).forEach(function(root) {
      var isCarousel = root.classList.contains('dr-fera--carousel');
      root.querySelectorAll('.fera-averageRating-count-str').forEach(function(el) {
        var countEl = el.querySelector('.fera-averageRating-count-total');
        if (countEl && !el.dataset.drTransformed) {
          var count = countEl.textContent.trim();
          el.innerHTML = isCarousel
            ? '<span class="fera-averageRating-count-total">' + count + '</span> ביקורות מאומתות'
            : 'סה"כ <span class="fera-averageRating-count-total">' + count + '</span> חוות דעת';
          el.dataset.drTransformed = 'true';
        }
      });
    });
  }

  /**
   * PDP (CRO v1): product reviews inside the product info column become a
   * scroll-snap carousel of the current page of reviews, followed by an end
   * card. The end card (and the "N ביקורות מאומתות" line) unfolds Fera's native
   * list (search + pagination) in place. Dots mirror the scroll position; on
   * mouse/trackpad devices, arrows either side of them page the cards.
   */
  function unfoldProductReviews(root) {
    if (root.dataset.drView === 'list') return;
    root.dataset.drView = 'list';
    var items = root.querySelector('.fera-reviews-body-items');
    // Fera's masonry still holds the heights it measured before the carousel
    // took over, and only re-measures ~0.8s later (a tall white gap until
    // then). A resize event makes it re-measure now; the list stays
    // transparent until the new height lands.
    root.classList.add('dr-fera--unfolding');
    root.classList.remove('dr-fera--carousel');
    toArray(root.querySelectorAll('.dr-fera-nav, .dr-fera-endcard')).forEach(function(el) { el.remove(); });
    toArray(root.querySelectorAll('.fera-averageRating-count-str[role="button"]')).forEach(function(el) {
      el.removeAttribute('role');
      el.removeAttribute('tabindex');
    });
    var revealed = false;
    var reveal = function() {
      if (revealed) return;
      revealed = true;
      observer.disconnect();
      requestAnimationFrame(function() { root.classList.remove('dr-fera--unfolding'); });
    };
    var observer = new MutationObserver(reveal);
    if (items) observer.observe(items, { attributes: true, attributeFilter: ['style'] });
    setTimeout(reveal, 600);
    window.dispatchEvent(new Event('resize'));
    root.scrollIntoView({ block: 'start' });
  }

  function carouselizeProductReviews(scope) {
    getWidgetRootsFromScope(scope).forEach(function(root) {
      if (!root.matches('.fera-productReviews-widget')) return;
      if (!root.closest('.product__info-container')) return;
      if (root.dataset.drView === 'list') return;

      root.classList.add('dr-fera--carousel');
      var items = root.querySelector('.fera-reviews-body-items');
      if (!items || !items.querySelector('.fera-review')) return;

      var countEl = root.querySelector('.fera-averageRating-count-total');
      var count = countEl ? countEl.textContent.trim() : '';
      var avgEl = root.querySelector('.fera-averageRating-average-number');
      var avg = avgEl ? avgEl.textContent.trim() : '';

      if (!items.querySelector('.dr-fera-endcard')) {
        var card = document.createElement('div');
        card.className = 'dr-fera-endcard';
        card.innerHTML =
          (avg ? '<span class="dr-fera-endcard__score">' + avg + '</span>' : '') +
          '<button type="button" class="dr-fera-endcard__link">' +
          (count ? 'לכל ' + count + ' הביקורות' : 'לכל הביקורות') + '</button>' +
          '<span class="dr-fera-endcard__note">כולל חיפוש בביקורות</span>';
        card.querySelector('button').addEventListener('click', function() {
          unfoldProductReviews(root);
        });
        items.appendChild(card);
      }

      // The underlined count in the summary does what the end card does
      toArray(root.querySelectorAll('.fera-averageRating-count-str:not([role])')).forEach(function(el) {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.addEventListener('click', function() {
          unfoldProductReviews(root);
        });
        el.addEventListener('keydown', function(e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          unfoldProductReviews(root);
        });
      });

      var slides = items.children.length;
      var nav = root.querySelector('.dr-fera-nav');
      var dotsEl = nav && nav.querySelector('.dr-fera-dots');
      if (!nav) {
        // RTL row: previous (right) · dots · next (left)
        nav = document.createElement('div');
        nav.className = 'dr-fera-nav';
        nav.innerHTML =
          '<button type="button" class="dr-fera-nav__btn" data-dir="-1" aria-label="לביקורת הקודמת" disabled>' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6 3l5 5-5 5"/></svg></button>' +
          '<div class="dr-fera-dots" aria-hidden="true"></div>' +
          '<button type="button" class="dr-fera-nav__btn" data-dir="1" aria-label="לביקורת הבאה">' +
          '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M10 3L5 8l5 5"/></svg></button>';
        items.insertAdjacentElement('afterend', nav);
        dotsEl = nav.querySelector('.dr-fera-dots');
        var buttons = toArray(nav.querySelectorAll('.dr-fera-nav__btn'));
        var step = function() {
          return items.firstElementChild ? items.firstElementChild.getBoundingClientRect().width + 12 : 1;
        };
        var sync = function() {
          var pos = Math.abs(items.scrollLeft);
          var max = items.scrollWidth - items.clientWidth;
          var index = Math.round(pos / step());
          toArray(dotsEl.children).forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === index);
          });
          buttons[0].disabled = pos < 2;
          buttons[1].disabled = pos > max - 2;
        };
        buttons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            // RTL track: later cards sit to the left, at negative scrollLeft
            items.scrollBy({ left: -Number(btn.dataset.dir) * step(), behavior: 'smooth' });
          });
        });
        items.addEventListener('scroll', sync, { passive: true });
      }
      if (dotsEl.children.length !== slides) {
        dotsEl.innerHTML = new Array(slides + 1).join('<span></span>');
        if (dotsEl.firstElementChild) dotsEl.firstElementChild.classList.add('is-active');
      }
    });
  }

  /**
   * Restructure reviewer info section with avatar + name/location flex row.
   * Creates: .dr-fera-reviewer > [avatar img] + .dr-fera-reviewer__info > [name, location]
   * Moves the wrapper above .fera-review-ratingAndDate (stars + date)
   * Applies to both All Reviews and Product Reviews widgets
   */
  function restructureReviewerInfo(scope) {
    // Get avatar URL from global (set by theme.liquid)
    var avatarUrl = window.drFeraAvatarUrl;
    if (!avatarUrl) return;

    getWidgetRootsFromScope(scope).forEach(function(root) {
      // Find all customer name elements that haven't been restructured yet (both widget types)
      var nameEls = root.querySelectorAll('.fera-review .fera-customer-display-name:not([data-dr-restructured])');

      nameEls.forEach(function(nameEl) {
        // Mark as processed immediately to prevent double-processing
        nameEl.dataset.drRestructured = 'true';

        // Get the review content container and ratingAndDate element
        var reviewContent = nameEl.closest('.fera-review-content');
        var ratingAndDate = reviewContent ? reviewContent.querySelector('.fera-review-ratingAndDate') : null;

        // Get the adjacent location element (nextElementSibling)
        var locationEl = nameEl.nextElementSibling;
        if (!locationEl || !locationEl.classList.contains('fera-customer-display-location')) {
          locationEl = null;
        }

        // Create the wrapper structure
        var wrapper = document.createElement('div');
        wrapper.className = 'dr-fera-reviewer';

        // Create avatar image
        var avatar = document.createElement('img');
        avatar.className = 'dr-fera-reviewer__avatar';
        avatar.src = avatarUrl;
        avatar.alt = '';
        avatar.setAttribute('aria-hidden', 'true');

        // Create info container
        var infoContainer = document.createElement('div');
        infoContainer.className = 'dr-fera-reviewer__info';

        // Move name and location into info container
        infoContainer.appendChild(nameEl);
        if (locationEl) {
          infoContainer.appendChild(locationEl);
        }

        // Assemble: wrapper > avatar + infoContainer
        wrapper.appendChild(avatar);
        wrapper.appendChild(infoContainer);

        // Insert wrapper before ratingAndDate (above stars), or fallback to reviewContent start
        if (ratingAndDate) {
          ratingAndDate.parentNode.insertBefore(wrapper, ratingAndDate);
        } else if (reviewContent) {
          reviewContent.insertBefore(wrapper, reviewContent.firstChild);
        }
      });
    });
  }

  /**
   * Move media carousel into .fera-review-content, after .fera-review-ratingAndDate.
   * This keeps all content together and allows proper visual ordering.
   * Applies to both All Reviews and Product Reviews widgets
   */
  function moveMediaIntoContent(scope) {
    getWidgetRootsFromScope(scope).forEach(function(root) {
      // Find all review cards that haven't had their media moved yet (both widget types)
      var reviewCards = root.querySelectorAll('.fera-review:not([data-dr-media-moved])');

      reviewCards.forEach(function(reviewCard) {
        // Find the media carousel and review content
        var mediaCarousel = reviewCard.querySelector('.fera-media-carousel');
        var reviewContent = reviewCard.querySelector('.fera-review-content');
        var ratingAndDate = reviewContent ? reviewContent.querySelector('.fera-review-ratingAndDate') : null;

        // Only proceed if we have all required elements.
        // We intentionally do not mark as moved yet so future mutation passes can retry.
        if (!mediaCarousel || !reviewContent || !ratingAndDate) return;

        // Insert media after ratingAndDate (before the next sibling)
        if (ratingAndDate.nextSibling) {
          reviewContent.insertBefore(mediaCarousel, ratingAndDate.nextSibling);
        } else {
          reviewContent.appendChild(mediaCarousel);
        }

        // Mark only after a successful move.
        reviewCard.dataset.drMediaMoved = 'true';
      });
    });
  }

  var DR_FERA_SHOW_LESS_LABEL = 'הראה פחות';

  /**
   * Inject a "Show Less" link into the full-text view (once per card) so the
   * user can collapse an expanded review back to its truncated state.
   */
  function ensureShowLessLink(full) {
    if (full.querySelector('.dr-fera-truncatedText-showLess')) return;
    var link = document.createElement('a');
    link.href = '#';
    link.className = 'fera-link dr-fera-truncatedText-showLess';
    link.textContent = DR_FERA_SHOW_LESS_LABEL;
    full.appendChild(document.createTextNode(' '));
    full.appendChild(link);
  }

  /**
   * Hijack "Show More" / "Show Less" link clicks so the review body expands
   * and collapses in place, bypassing Fera's onShowMore callback that would
   * otherwise open the modal. Capture phase + stopImmediatePropagation runs
   * before Fera's bubble handler.
   */
  function expandInPlaceOnShowMore() {
    document.addEventListener('click', function(e) {
      var moreLink = e.target.closest('.fera-truncatedText-showMore');
      var lessLink = e.target.closest('.dr-fera-truncatedText-showLess');
      var link = moreLink || lessLink;
      if (!link) return;

      var feraRoot = link.closest(DR_FERA_WIDGET_ROOTS_SELECTOR);
      if (!feraRoot) return;

      var wrap = link.closest('.fera-truncatedText');
      if (!wrap) return;

      var truncated = wrap.querySelector('.fera-truncatedText--truncated');
      var full = wrap.querySelector('.fera-truncatedText--full');
      if (!truncated || !full) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (moreLink) {
        truncated.classList.add('fera-hidden');
        full.classList.remove('fera-hidden');
        ensureShowLessLink(full);
      } else {
        full.classList.add('fera-hidden');
        truncated.classList.remove('fera-hidden');
      }

      // Nudge Fera's masonry layout to recompute card positions now that this
      // card's height changed. Fera's reviews-body listens to window 'resize'
      // and re-runs masonry.layout(); without this neighboring cards stay in
      // their old positions until the next resize/scroll tick.
      window.dispatchEvent(new Event('resize'));
    }, true);
  }

  /**
   * Block clicks on review cards except for media, customer name, and show more links.
   * Prevents modal popup from opening on non-allowed areas.
   */
  function blockReviewClicks() {
    document.addEventListener('click', function(e) {
      // Ignore non-Fera clicks as early as possible.
      var feraRoot = e.target.closest(DR_FERA_WIDGET_ROOTS_SELECTOR);
      if (!feraRoot) return;

      // Check if click is inside a review card
      var reviewCard = e.target.closest('.fera-review');
      if (!reviewCard) return;

      // Check if click is on allowed elements
      var isMedia = e.target.closest('.fera-media, .fera-media-carousel, .fera-media-thumbnail');
      var isCustomerName = e.target.closest('.fera-review-author-name, .fera-customer-name, .fera--clickable, [data-fera-customer-name]');
      var isShowMore = e.target.closest('.fera-truncatedText-showMore');
      var isProductLink = e.target.closest('.fera-review-product, .fera-review-product-link, [data-fera-component="product"]');
      
      // Allow clicks on media, customer name, show more links, and product link
      if (isMedia || isCustomerName || isShowMore || isProductLink) {
        return; // Let the click through
      }

      // Block all other clicks inside the review card
      e.preventDefault();
      e.stopPropagation();

      // PDP carousel: the whole card is the "show more" target (tap size)
      if (reviewCard.closest('.dr-fera--carousel')) {
        var more = reviewCard.querySelector('.fera-truncatedText--truncated .fera-truncatedText-showMore');
        if (more && !reviewCard.querySelector('.fera-truncatedText--truncated.fera-hidden')) more.click();
      }
    }, true); // Use capture phase to intercept before Fera's handlers
  }

  function getNodeElement(node) {
    if (!node) return null;
    if (node.nodeType === 1) return node;
    if (node.nodeType === 3) return node.parentElement || null;
    return null;
  }

  function collectWidgetRootsFromMutations(mutations) {
    var roots = [];

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      var target = getNodeElement(mutation.target);
      if (target) {
        getWidgetRootsFromScope(target).forEach(function(root) {
          pushUnique(roots, root);
        });
      }

      var addedNodes = mutation.addedNodes;
      for (var j = 0; j < addedNodes.length; j++) {
        var addedEl = getNodeElement(addedNodes[j]);
        if (!addedEl) continue;
        getWidgetRootsFromScope(addedEl).forEach(function(root) {
          pushUnique(roots, root);
        });
      }
    }

    return roots;
  }

  function mutationTouchesCustomerModal(mutations) {
    function isInsideCustomerModal(el) {
      return !!(
        el &&
        el.nodeType === 1 &&
        (
          (el.matches && el.matches('.fera-customer-modal, .fera-customer-modal *, .fera-modal-dialog, .fera-modal-dialog *, .fera-modal, .fera-modal *')) ||
          (el.closest && el.closest('.fera-customer-modal, .fera-modal-dialog, .fera-modal'))
        )
      );
    }

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      var target = getNodeElement(mutation.target);
      if (isInsideCustomerModal(target)) {
        return true;
      }

      var addedNodes = mutation.addedNodes || [];
      for (var j = 0; j < addedNodes.length; j++) {
        var addedEl = getNodeElement(addedNodes[j]);
        if (isInsideCustomerModal(addedEl)) {
          return true;
        }
      }
    }

    return false;
  }

  function runAllCustomizations(scope) {
    carouselizeProductReviews(scope);
    transformReviewCount(scope);
    restructureReviewerInfo(scope);
    moveMediaIntoContent(scope);
    applyReviewProductSeriesAccents(scope);
    fixShowMoreLoadingState(scope);
  }

  /**
   * Parse product handle from any product URL.
   */
  function getProductHandleFromUrl(url) {
    if (!url) return '';

    var normalized = String(url).trim();
    if (!normalized) return '';

    // Handle absolute and relative URLs
    try {
      var parsed = new URL(normalized, window.location.origin);
      var segments = parsed.pathname.split('/').filter(Boolean);
      var productIndex = segments.indexOf('products');
      if (productIndex !== -1 && segments[productIndex + 1]) {
        return decodeURIComponent(segments[productIndex + 1]).toLowerCase();
      }
    } catch (e) {
      // Fallback regex for malformed URLs
      var match = normalized.match(/\/products\/([^/?#]+)/i);
      if (match && match[1]) {
        return decodeURIComponent(match[1]).toLowerCase();
      }
    }

    return '';
  }

  /**
   * Add per-product accent on review product blocks.
   * Scope: review cards only (not modal).
   */
  function applyReviewProductSeriesAccents(scope) {
    getWidgetRootsFromScope(scope).forEach(function(root) {
      var productBlocks = root.querySelectorAll('.fera-review .fera-review-product');

      productBlocks.forEach(function(block) {
        var link = block.querySelector('.fera-review-product-link[href], a[href]');
        var href = link ? link.getAttribute('href') : '';
        var handle = getProductHandleFromUrl(href);
        var color = handle ? DR_FERA_PRODUCT_SERIES_COLORS[handle] : '';

        if (color) {
          if (!block.classList.contains('dr-fera-review-product--accented')) {
            block.classList.add('dr-fera-review-product--accented');
          }

          if (block.style.getPropertyValue('--dr-fera-series-color') !== color) {
            block.style.setProperty('--dr-fera-series-color', color);
          }

          if (block.dataset.drFeraAccentHandle !== handle) {
            block.dataset.drFeraAccentHandle = handle;
          }
        } else {
          if (block.classList.contains('dr-fera-review-product--accented')) {
            block.classList.remove('dr-fera-review-product--accented');
          }

          if (block.style.getPropertyValue('--dr-fera-series-color')) {
            block.style.removeProperty('--dr-fera-series-color');
          }

          if (block.dataset.drFeraAccentHandle) {
            delete block.dataset.drFeraAccentHandle;
          }
        }
      });
    });
  }

  /**
   * Normalize Show More loading state to RTL copy order:
   * "... בטעינה" [spinner]
   */
  function fixShowMoreLoadingState(scope) {
    var buttons = [];

    getWidgetRootsFromScope(scope).forEach(function(root) {
      root.querySelectorAll('.fera-reviews-showMore-btn').forEach(function(btn) {
        pushUnique(buttons, btn);
      });
    });

    document.querySelectorAll('.fera-customer-modal .fera-reviews-showMore-btn, .fera-modal-dialog .fera-reviews-showMore-btn, .fera-modal .fera-reviews-showMore-btn').forEach(function(btn) {
      pushUnique(buttons, btn);
    });

    buttons.forEach(function(btn) {
      var icon = btn.querySelector('[data-fera-icon-container]');
      var text = btn.querySelector('[data-fera-text-container]');
      if (!icon || !text) return;

      var textContent = (text.textContent || '').trim();
      var isLoading = btn.hasAttribute('disabled') && !icon.classList.contains('fera-hidden');
      var hasLoadingText = textContent.indexOf('בטעינה') !== -1;

      if (isLoading && hasLoadingText) {
        btn.classList.add('dr-fera-showmore--loading');
        if (textContent !== 'בטעינה...') {
          text.textContent = 'בטעינה...';
        }
      } else {
        btn.classList.remove('dr-fera-showmore--loading');
      }

    });
  }

  /**
   * Initialize Fera widget customizations
   */
  function init() {
    syncProductRatings();

    // Run transformations
    runAllCustomizations();
    
    // Block unwanted clicks
    blockReviewClicks();

    // Expand review body in place when "Show More" is clicked.
    expandInPlaceOnShowMore();

    // Keep one runtime reference for safety if init is ever called again.
    if (window.__drFeraWidgetRuntime) {
      return;
    }

    var runtime = {
      bootstrapObserver: null,
      rootObservers: [],
      pendingRoots: [],
      isMutationFlushScheduled: false
    };
    window.__drFeraWidgetRuntime = runtime;

    function isRootObserved(root) {
      for (var i = 0; i < runtime.rootObservers.length; i++) {
        if (runtime.rootObservers[i].root === root) return true;
      }
      return false;
    }

    function pruneDisconnectedRootObservers() {
      var active = [];
      for (var i = 0; i < runtime.rootObservers.length; i++) {
        var entry = runtime.rootObservers[i];
        if (entry.root && entry.root.isConnected) {
          active.push(entry);
        } else {
          entry.observer.disconnect();
        }
      }
      runtime.rootObservers = active;
    }

    function scheduleCustomizationFlush(roots) {
      if (Array.isArray(roots)) {
        roots.forEach(function(root) {
          if (root && root.isConnected) {
            pushUnique(runtime.pendingRoots, root);
          }
        });
      }

      if (runtime.isMutationFlushScheduled) return;
      runtime.isMutationFlushScheduled = true;

      requestAnimationFrame(function() {
        runtime.isMutationFlushScheduled = false;
        pruneDisconnectedRootObservers();

        var rootsToProcess = runtime.pendingRoots.slice();
        runtime.pendingRoots.length = 0;
        runAllCustomizations(rootsToProcess.length ? rootsToProcess : null);
      });
    }

    function observeWidgetRoot(root) {
      if (!root || !root.isConnected || isRootObserved(root)) return;

      var observer = new MutationObserver(function(mutations) {
        if (!mutations || !mutations.length) return;

        var discoveredRoots = collectWidgetRootsFromMutations(mutations);
        if (discoveredRoots.length) {
          discoveredRoots.forEach(observeWidgetRoot);
        }

        scheduleCustomizationFlush([root]);
      });

      observer.observe(root, { childList: true, subtree: true });
      runtime.rootObservers.push({ root: root, observer: observer });
    }

    function observeInitialRoots() {
      getWidgetRootsFromScope(document).forEach(observeWidgetRoot);
    }

    // Observe existing roots and watch for newly inserted roots.
    observeInitialRoots();
    runtime.bootstrapObserver = new MutationObserver(function(mutations) {
      if (!mutations || !mutations.length) return;

      var discoveredRoots = collectWidgetRootsFromMutations(mutations);
      var modalChanged = mutationTouchesCustomerModal(mutations);
      if (!discoveredRoots.length && !modalChanged) return;

      if (discoveredRoots.length) {
        discoveredRoots.forEach(observeWidgetRoot);
        scheduleCustomizationFlush(discoveredRoots);
      } else {
        // Modal updates can happen outside widget roots; run a global pass.
        scheduleCustomizationFlush(null);
      }
    });

    runtime.bootstrapObserver.observe(document.body, { childList: true, subtree: true });
    window.__drFeraWidgetObserver = runtime.bootstrapObserver;

    document.addEventListener('shopify:section:load', function(event) {
      syncProductRatings(event.target);
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
